module.exports = __webpack_public_path__ + "static/media/26-15.c0f05230.mp3";